// Owner contact + identity helpers, shared by the verify-step form (validation) and
// the multipart serializer (wire normalisation). The tel input renders a spaced
// international number ("+971 50 123 4567"); seller-service expects E.164, so the
// separators are stripped at both seams from this one place. Emirates IDs follow
// the same shape: entered however the seller reads them off the card, submitted
// digits-only.
import { validateMobile } from '@shared/utils'
import { OWNER_EMIRATES_ID_REGEX, OWNER_MOBILE_E164_REGEX } from '../constants/listingRequest'

export function toE164Mobile(value: string): string {
  return value.replace(/[\s()\-.]/g, '')
}

// Empty string when valid; otherwise the message to show under the field.
export function validateOwnerMobile(value: string): string {
  const normalized = toE164Mobile(value)
  if (!normalized) return 'Mobile number is required'
  if (!OWNER_MOBILE_E164_REGEX.test(normalized)) {
    return 'Include the country code, e.g. +971 50 123 4567'
  }
  return validateMobile(normalized)
}

// Emirates ID cards print the number as 784-1990-1234567-1. Rather than reformatting
// the field as the seller types — which fights the cursor — anything non-digit is
// stripped here, so pasted and hand-typed values both normalise.
export function toEmiratesIdDigits(value: string): string {
  return value.replace(/\D/g, '')
}

// Empty string when valid; otherwise the message to show under the field.
export function validateOwnerEmiratesId(value: string): string {
  const digits = toEmiratesIdDigits(value)
  if (!digits) return 'Emirates ID is required'
  if (!OWNER_EMIRATES_ID_REGEX.test(digits)) {
    return 'Emirates ID must be 15 digits, e.g. 784-1990-1234567-1'
  }
  return ''
}
